import React from 'react';
import { Settings as SettingsIcon, Save } from 'lucide-react';

const Settings = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-800 mb-6">Settings</h1>
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-6 max-w-2xl">
        <form>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Site Name</label>
              <input type="text" className="w-full px-4 py-2 border border-slate-200 rounded-lg" placeholder="HouseDesigns99" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
              <input type="email" className="w-full px-4 py-2 border border-slate-200 rounded-lg" placeholder="hello@housedesigns99.com" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Phone</label>
              <input type="text" className="w-full px-4 py-2 border border-slate-200 rounded-lg" placeholder="+91 98765 43210" />
            </div>
            <button type="submit" className="flex items-center gap-2 bg-amber-500 text-white px-6 py-2.5 rounded-lg hover:bg-amber-600 transition">
              <Save className="w-4 h-4" /> Save Settings
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Settings;
